<!-- Nothing renders until the site knows its scope, so the rail does not flash
     a placeholder pill on every load. -->
@if (selectedName) {
  @if (canSwitch) {
    <!-- The same dropdown the header's user menu uses, so the two panels in the
         shell look and behave alike. Items are projected into its own <ul>,
         which is why each entry has to be a direct <li>. -->
    <seech-dropdown
      id="scopeSwitcher"
      [direction]="menuDirection"
      [alignment]="'start'"
      [hideBorder]="true"
      [minWidth]="'15rem'"
      [disabled]="busy"
    >
      <button
        toggle
        type="button"
        class="scope-trigger"
        [disabled]="busy"
        [attr.aria-label]="'Change ' + label + '. Currently ' + selectedName"
        [title]="label + ': ' + selectedName"
      >
        <i
          class="scope-trigger__icon"
          [class.scope-trigger__icon--busy]="busy"
          [sch-icon]="busy ? 'autorenew-fill' : icon"
          aria-hidden="true"
        ></i>
        <span class="scope-trigger__text">
          <span class="scope-trigger__label">{{ label }}</span>
          <span class="scope-trigger__name">{{ selectedName }}</span>
        </span>
        <i class="scope-trigger__caret" [sch-icon]="'arrow-drop-down'" aria-hidden="true"></i>
      </button>

      <li class="scope-menu__head">Switch {{ label | lowercase }}</li>
      @for (option of options; track option.id) {
        <li>
          <button
            type="button"
            class="dropdown-item scope-option"
            [class.scope-option--current]="option.id === selectedId"
            [disabled]="busy"
            (click)="choose(option)"
          >
            <span class="scope-option__text">
              <span class="scope-option__name">{{ option.name }}</span>
              @if (option.hint) {
                <span class="scope-option__hint">{{ option.hint }}</span>
              }
            </span>
            @if (option.id === selectedId) {
              <i class="scope-option__check" [sch-icon]="'checkmark'" aria-hidden="true"></i>
            }
          </button>
        </li>
      }
    </seech-dropdown>
  } @else {
    <!-- One scope: the same pill without the caret or the panel. It reads as a
         statement of where you are rather than a control that does nothing. -->
    <span class="scope-static" [title]="label + ': ' + selectedName">
      <i class="scope-static__icon" [sch-icon]="icon" aria-hidden="true"></i>
      <span class="scope-trigger__text">
        <span class="scope-trigger__label">{{ label }}</span>
        <span class="scope-trigger__name">{{ selectedName }}</span>
      </span>
    </span>
  }
}
